var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg_({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150.61328pt",
    height: "375.97656pt",
    viewBox: "0 0 150.61328 375.97656",
    id: "svg636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.3125,2.828125 C 2.226562,3.015625 2.039062,3.109375 1.75,3.109375 1.664062,3.109375 1.582031,3.09375 1.5,3.0625 L 1.078125,2.953125 C 0.597656,2.828125 0.28125,2.578125 0.125,2.203125 0.0390625,2.015625 0,1.796875 0,1.546875 V 0.71875 C 0,0.582031 0.0703125,0.515625 0.21875,0.515625 c 0.132812,0 0.203125,0.066406 0.203125,0.203125 v 0.953125 c 0,0.1875 0.0625,0.359375 0.1875,0.515625 0.125,0.164062 0.28125,0.273438 0.46875,0.328125 L 1.5,2.625 c 0.09375,0.019531 0.175781,0.03125 0.25,0.03125 0.257812,0 0.390625,-0.179688 0.390625,-0.53125 V 1.75 c 0,-0.148438 0.070313,-0.21875 0.21875,-0.21875 0.144531,0 0.21875,0.070312 0.21875,0.21875 v 0.5 c 0,0.257812 0.101563,0.476562 0.3125,0.65625 C 2.992188,3 3.101562,3.0625 3.21875,3.09375 c 0.070312,0.00781 0.132812,0.015625 0.1875,0.015625 0.300781,0 0.453125,-0.171875 0.453125,-0.515625 V 1.765625 c 0,-0.148437 0.070313,-0.21875 0.21875,-0.21875 0.144531,0 0.21875,0.070313 0.21875,0.21875 v 0.9375 c 0,0.332031 -0.152344,0.582031 -0.453125,0.75 -0.136719,0.0625 -0.277344,0.09375 -0.421875,0.09375 -0.0625,0 -0.132813,-0.00781 -0.203125,-0.015625 C 2.75,3.40625 2.445312,3.171875 2.3125,2.828125 Z m 0,0",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.421875,1.671875 c 0,0.4375 0.21875,0.710937 0.65625,0.828125 L 1.5,2.625 c 0.082031,0.019531 0.164062,0.03125 0.25,0.03125 0.257812,0 0.390625,-0.179688 0.390625,-0.53125 V 1.453125 l -1.0625,-0.28125 C 1.003906,1.148438 0.945312,1.140625 0.90625,1.140625 0.769531,1.140625 0.65625,1.1875 0.5625,1.28125 0.46875,1.382812 0.421875,1.515625 0.421875,1.671875 Z M 0,1.546875 c 0,-0.304687 0.15625,-0.542969 0.46875,-0.71875 0.132812,-0.085937 0.273438,-0.125 0.421875,-0.125 0.0625,0 0.117187,0.007813 0.171875,0.03125 l 1.296875,0.34375 c 0.476563,0.125 0.878906,0.335937 1.203125,0.640625 0.351562,0.332031 0.59375,0.769531 0.71875,1.3125 0.00781,0.019531 0.015625,0.039062 0.015625,0.0625 0,0.132812 -0.074219,0.203125 -0.21875,0.203125 C 3.953125,3.296875 3.882812,3.25 3.875,3.15625 3.84375,2.914062 3.753906,2.675781 3.609375,2.4375 3.335938,2 2.992188,1.722656 2.578125,1.609375 V 2.25 C 2.578125,2.488281 2.5,2.6875 2.34375,2.84375 2.1875,3.007812 1.984375,3.09375 1.734375,3.09375 1.648438,3.09375 1.570312,3.082031 1.5,3.0625 L 1.078125,2.953125 C 0.578125,2.816406 0.253906,2.570312 0.109375,2.21875 0.0351562,2.039062 0,1.816406 0,1.546875 Z m 0,0",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.109375,3.03125 0.09375,1.796875 C 0.03125,1.753906 0,1.691406 0,1.609375 0,1.546875 0.0195312,1.492188 0.0625,1.453125 0.113281,1.410156 0.164062,1.390625 0.21875,1.390625 l 3.859375,0.15625 c 0.144531,0 0.21875,0.066406 0.21875,0.203125 0,0.15625 -0.078125,0.234375 -0.234375,0.234375 L 1.015625,1.84375 2.90625,3.015625 C 2.96875,3.046875 3,3.101562 3,3.1875 3,3.320312 2.9375,3.394531 2.8125,3.40625 L 0.984375,3.546875 4.171875,5.125 c 0.082031,0.039062 0.125,0.101562 0.125,0.1875 0,0.144531 -0.074219,0.21875 -0.21875,0.21875 -0.03125,0 -0.0625,-0.00781 -0.09375,-0.015625 L 0.109375,3.59375 C 0.0351562,3.550781 0,3.488281 0,3.40625 0,3.257812 0.0664062,3.1875 0.203125,3.1875 Z m 0,0",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.421875,2.5 c 0,0.144531 -0.070313,0.21875 -0.203125,0.21875 C 0.0703125,2.71875 0,2.644531 0,2.5 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 l 3.921875,1.046875 c 0.101563,0.03125 0.15625,0.101563 0.15625,0.21875 0,0.132813 -0.074219,0.203125 -0.21875,0.203125 -0.023437,0 -0.042969,0 -0.0625,0 L 0.421875,1 Z m 0,0",
    id: "path4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.140625,2.640625 V 1.46875 L 0.421875,1 v 1.5 c 0,0.144531 -0.070313,0.21875 -0.203125,0.21875 C 0.0703125,2.71875 0,2.644531 0,2.5 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 l 3.859375,1.03125 c 0.144531,0.039062 0.21875,0.140625 0.21875,0.296875 V 3.53125 C 4.296875,3.675781 4.222656,3.75 4.078125,3.75 3.929688,3.75 3.859375,3.675781 3.859375,3.53125 V 1.921875 l -1.28125,-0.34375 v 1.0625 c 0,0.132813 -0.074219,0.203125 -0.21875,0.203125 -0.148437,0 -0.21875,-0.070312 -0.21875,-0.203125 z m 0,0",
    id: "path5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 4.078125,1.53125 c 0.144531,0.039062 0.21875,0.140625 0.21875,0.296875 V 3.15625 c 0,0.21875 -0.09375,0.410156 -0.28125,0.578125 C 3.828125,3.910156 3.617188,4 3.390625,4 3.328125,4 3.269531,3.992188 3.21875,3.984375 L 1.078125,3.40625 C 0.359375,3.207031 0,2.738281 0,2 V 0.671875 C 0,0.609375 0.0195312,0.554688 0.0625,0.515625 0.101562,0.484375 0.15625,0.476562 0.21875,0.5 Z M 3.859375,1.921875 0.421875,1 v 1.109375 c 0,0.1875 0.0625,0.359375 0.1875,0.515625 0.125,0.164062 0.28125,0.273438 0.46875,0.328125 L 3.21875,3.53125 C 3.269531,3.539062 3.320312,3.546875 3.375,3.546875 3.519531,3.546875 3.632812,3.5 3.71875,3.40625 3.8125,3.3125 3.859375,3.1875 3.859375,3.03125 Z m 0,0",
    id: "path6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.734375,4.34375 H 0 V 0.265625 C 0.1875,0.253906 0.363281,0.28125 0.53125,0.34375 c 0.269531,0.101562 0.539062,0.269531 0.8125,0.5 0.269531,0.226562 0.582031,0.5625 0.9375,1 0.550781,0.675781 0.988281,1.128906 1.3125,1.359375 0.320312,0.238281 0.628906,0.359375 0.921875,0.359375 0.300781,0 0.550781,-0.109375 0.75,-0.328125 0.207031,-0.210937 0.3125,-0.492187 0.3125,-0.84375 0,-0.367187 -0.109375,-0.65625 -0.328125,-0.875 C 5.03125,1.296875 4.726562,1.1875 4.34375,1.1875 L 4.421875,0.40625 C 5.003906,0.457031 5.445312,0.65625 5.75,1 6.050781,1.351562 6.203125,1.820312 6.203125,2.40625 6.203125,3 6.035156,3.46875 5.703125,3.8125 5.378906,4.164062 4.976562,4.34375 4.5,4.34375 4.25,4.34375 4.003906,4.289062 3.765625,4.1875 3.523438,4.082031 3.269531,3.910156 3,3.671875 2.738281,3.441406 2.378906,3.054688 1.921875,2.515625 1.535156,2.054688 1.273438,1.757812 1.140625,1.625 1.003906,1.5 0.867188,1.394531 0.734375,1.3125 Z m 0,0",
    id: "path7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3.046875,0.359375 c 0.726563,0 1.316406,0.070313 1.765625,0.21875 C 5.257812,0.734375 5.601562,0.957031 5.84375,1.25 6.082031,1.550781 6.203125,1.925781 6.203125,2.375 6.203125,2.707031 6.132812,3 6,3.25 5.875,3.5 5.679688,3.703125 5.421875,3.859375 5.171875,4.023438 4.863281,4.15625 4.5,4.25 4.144531,4.34375 3.660156,4.390625 3.046875,4.390625 2.328125,4.390625 1.742188,4.3125 1.296875,4.15625 0.847656,4.007812 0.5,3.785156 0.25,3.484375 0.0078125,3.191406 -0.109375,2.820312 -0.109375,2.375 -0.109375,1.78125 0.101562,1.3125 0.53125,0.96875 1.050781,0.5625 1.890625,0.359375 3.046875,0.359375 Z m 0,0.78125 c -1.011719,0 -1.6875,0.117187 -2.03125,0.359375 -0.335937,0.238281 -0.5,0.53125 -0.5,0.875 0,0.351562 0.164063,0.644531 0.5,0.875 0.34375,0.238281 1.019531,0.359375 2.03125,0.359375 1.019531,0 1.695313,-0.121094 2.03125,-0.359375 0.332031,-0.230469 0.5,-0.527344 0.5,-0.890625 0,-0.34375 -0.148437,-0.621094 -0.4375,-0.828125 -0.375,-0.261719 -1.074219,-0.390625 -2.09375,-0.390625 z m 0,0",
    id: "path8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0.640625 h 6.1875 v 0.8125 H 0.734375 V 4.5 H 0 Z m 0,0",
    id: "path9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.65625,1.203125 C 2.75,0.953125 2.878906,0.765625 3.046875,0.640625 3.210938,0.523438 3.414062,0.46875 3.65625,0.46875 c 0.351562,0 0.648438,0.128906 0.890625,0.390625 0.25,0.257813 0.375,0.597656 0.375,1.015625 0,0.425781 -0.125,0.769531 -0.375,1.03125 C 4.296875,3.175781 3.992188,3.3125 3.640625,3.3125 3.410156,3.3125 3.210938,3.25 3.046875,3.125 2.878906,3.007812 2.75,2.828125 2.65625,2.578125 2.5625,2.878906 2.40625,3.109375 2.1875,3.265625 1.96875,3.421875 1.707031,3.5 1.40625,3.5 0.976562,3.5 0.625,3.347656 0.34375,3.046875 0.0625,2.753906 -0.078125,2.367188 -0.078125,1.890625 -0.078125,1.410156 0.0625,1.019531 0.34375,0.71875 0.632812,0.425781 0.992188,0.28125 1.421875,0.28125 1.734375,0.28125 2,0.359375 2.21875,0.515625 2.4375,0.679688 2.582031,0.910156 2.65625,1.203125 Z M 3.671875,1.09375 c -0.230469,0 -0.417969,0.070312 -0.5625,0.21875 -0.148437,0.144531 -0.21875,0.335938 -0.21875,0.578125 0,0.238281 0.070313,0.429687 0.21875,0.578125 0.144531,0.144531 0.320313,0.21875 0.53125,0.21875 0.21875,0 0.398437,-0.078125 0.546875,-0.234375 C 4.34375,2.304688 4.421875,2.117188 4.421875,1.890625 4.421875,1.660156 4.347656,1.46875 4.203125,1.3125 4.054688,1.164062 3.878906,1.09375 3.671875,1.09375 Z M 1.40625,0.890625 c -0.167969,0 -0.335938,0.039063 -0.5,0.125 C 0.75,1.097656 0.625,1.21875 0.53125,1.375 c -0.085938,0.164062 -0.125,0.335938 -0.125,0.515625 0,0.289063 0.09375,0.53125 0.28125,0.71875 0.1875,0.1875 0.421875,0.28125 0.703125,0.28125 0.289063,0 0.53125,-0.101563 0.71875,-0.296875 0.1875,-0.1875 0.28125,-0.429688 0.28125,-0.71875 0,-0.28125 -0.09375,-0.515625 -0.28125,-0.703125 C 1.921875,0.984375 1.6875,0.890625 1.40625,0.890625 Z m 0,0",
    id: "path10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2.421875,0.28125 c 0.570313,0 1.035156,0.054688 1.390625,0.171875 0.351562,0.125 0.625,0.300781 0.8125,0.53125 C 4.820312,1.222656 4.921875,1.519531 4.921875,1.875 4.921875,2.144531 4.863281,2.378906 4.75,2.578125 4.644531,2.773438 4.492188,2.9375 4.296875,3.0625 4.097656,3.195312 3.851562,3.300781 3.5625,3.375 3.28125,3.445312 2.898438,3.484375 2.421875,3.484375 c -0.585937,0 -1.054687,-0.0625 -1.40625,-0.1875 C 0.671875,3.179688 0.398438,3.003906 0.203125,2.765625 0.015625,2.535156 -0.078125,2.238281 -0.078125,1.875 c 0,-0.46875 0.1640625,-0.839844 0.5,-1.109375 0.40625,-0.324219 1.070313,-0.484375 2,-0.484375 z m 0,0.625 C 1.609375,0.90625 1.066406,1 0.796875,1.1875 0.535156,1.375 0.40625,1.601562 0.40625,1.875 c 0,0.28125 0.132812,0.515625 0.40625,0.703125 0.269531,0.1875 0.804688,0.28125 1.609375,0.28125 0.800781,0 1.332031,-0.09375 1.59375,-0.28125 C 4.285156,2.390625 4.421875,2.15625 4.421875,1.875 4.421875,1.59375 4.300781,1.375 4.0625,1.21875 3.769531,1.007812 3.222656,0.90625 2.421875,0.90625 Z m 0,0",
    id: "path11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0.5 H 4.90625 V 1.15625 H 0.578125 V 3.5625 H 0 Z m 0,0",
    id: "path12"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g637",
    transform: "translate(-223.97266,-15.171875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 354.88021,228.16146 V 408.80209 H 309.76042 V 228.16146 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.07812,271.04167 0.64063,-0.16146 0.80208,-0.16146 0.47917,-0.47916 0.47917,-0.64063 0.32291,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 350.07812,271.19792 H 322.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.16146,268.31771 0.15625,0.64063 0.16146,0.64062 0.47916,0.64063 0.64063,0.47916 1.28125,0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 320,268.31771 V 232.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.88021,230.23959 -1.28125,0.32291 -0.64063,0.47917 -0.47916,0.47917 -0.16146,0.79687 -0.15625,0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.88021,230.07813 h 27.19791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 352.80208,232.95834 -0.16146,-0.64063 -0.16145,-0.79687 -0.95834,-0.95834 -0.80208,-0.16145 -0.64063,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 352.95833,232.95834 v 35.35937",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,-0.00124567 1.118541,-0.157496 2.238332,-0.641871 3.040416,-1.438746 3.681041,-2.402287 3.998749,-3.360621 v -1.28125 L 3.681041,-5.600204 3.040416,-6.558537 2.238332,-7.360621 1.118541,-7.839787 l -1.119792,-0.161459 -1.119792,0.161459 -1.119791,0.479166 -0.796875,0.802084 -0.640625,0.958333 -0.322917,0.958333 v 1.28125 l 0.322917,0.958334 0.640625,0.963541 0.796875,0.796875 1.119791,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,251.04,191.04)",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 337.59896,247.83855 -5.76042,5.76041 m 0,-5.76041 5.76042,5.76041",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,6.31333e-4 0.800832,-0.160827 1.759166,-1.11916 1.920624,-1.921244 1.759166,-2.718119 1.279999,-3.202494 0.800832,-3.68166 l -0.802083,-0.15625 -0.796875,0.15625 -0.484375,0.479166 -0.479167,0.484375 -0.15625,0.796875 0.15625,0.802084 0.479167,0.479166 0.484375,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,236.04,189.47999)",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 350.07812,316.16146 350.71875,316 l 0.80208,-0.16145 0.47917,-0.47917 0.47917,-0.64063 0.32291,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 350.07812,316.31771 H 322.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.16146,313.4375 0.15625,0.64063 0.16146,0.64062 0.47916,0.64063 0.64063,0.47917 1.28125,0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 320,313.4375 V 278.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.88021,275.52084 -0.64063,0.16146 -0.64062,0.15625 -0.64063,0.47916 -0.47916,0.48438 -0.16146,0.79687 -0.15625,0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.88021,275.35938 h 27.19791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 352.80208,278.23959 -0.16146,-0.64063 -0.16145,-0.79687 -0.47917,-0.48438 -0.47917,-0.47916 -0.80208,-0.15625 -0.64063,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 352.95833,278.23959 V 313.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.001251,-0.001449 1.119792,-0.15625 1.119791,-0.484375 0.802084,-0.796875 0.640625,-0.963542 0.317708,-0.958333 v -1.28125 L 3.681041,-5.600407 3.040416,-6.558741 2.238332,-7.360824 1.118541,-7.839991 l -1.119792,-0.161458 -1.119792,0.161458 -1.119791,0.479167 -0.796875,0.802083 -0.640625,0.958334 -0.322917,0.958333 v 1.28125 l 0.322917,0.958333 0.640625,0.963542 0.796875,0.796875 1.119791,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,251.04,224.87999)",
    id: "path33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 337.59896,292.95834 -5.76042,5.76041 m 0,-5.76041 5.76042,5.76041",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,4.12e-4 0.800832,-0.161046 1.759166,-1.11938 1.920624,-1.921463 1.759166,-2.718338 1.279999,-3.197505 0.800832,-3.68188 l -0.802083,-0.15625 -0.796875,0.15625 -0.963542,0.963542 -0.15625,0.796875 0.15625,0.802083 0.479167,0.479167 0.484375,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,236.04,223.32)",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.07812,361.4375 0.64063,-0.15625 0.80208,-0.16145 L 352,360.64063 352.47917,360 l 0.32291,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 350.07812,361.59896 H 322.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.16146,358.71875 0.15625,0.64063 0.16146,0.64062 0.47916,0.64063 0.64063,0.47917 0.64062,0.16145 0.64063,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 320,358.71875 V 323.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.88021,320.64063 -0.64063,0.16146 -0.64062,0.15625 -0.64063,0.47916 -0.47916,0.48438 -0.16146,0.79687 -0.15625,0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.88021,320.47917 h 27.19791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 352.80208,323.35938 -0.16146,-0.64063 -0.16145,-0.79687 L 352,321.4375 l -0.47917,-0.47916 -0.80208,-0.15625 -0.64063,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 352.95833,323.35938 v 35.35937",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,-0.00165233 1.118541,-0.157902 2.238332,-0.642277 3.040416,-1.439152 3.681041,-2.397486 3.998749,-3.361027 v -1.28125 L 3.681041,-5.600611 3.040416,-6.558944 2.238332,-7.361027 1.118541,-7.840194 l -1.119792,-0.161458 -1.119792,0.161458 -1.119791,0.479167 -0.796875,0.802083 -0.640625,0.958333 -0.322917,0.958334 v 1.28125 l 0.322917,0.963541 0.640625,0.958334 0.796875,0.796875 1.119791,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,251.04,258.71999)",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 337.59896,338.07813 -5.76042,5.76042 m 0,-5.76042 5.76042,5.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,2.08667e-4 0.800832,-0.16125 1.759166,-1.119583 1.920624,-1.921666 1.759166,-2.718541 1.279999,-3.197708 0.800832,-3.682083 l -0.802083,-0.15625 -0.796875,0.15625 -0.963542,0.963542 -0.15625,0.796875 0.15625,0.802083 0.479167,0.479167 0.484375,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,236.04,257.16)",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 350.07812,406.5625 0.64063,-0.16145 0.80208,-0.16146 0.47917,-0.47917 0.47917,-0.64062 0.32291,-1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 350.07812,406.71875 H 322.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 320.16146,403.83855 0.15625,0.64062 0.16146,0.64063 0.47916,0.64062 0.64063,0.47917 1.28125,0.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 320,403.83855 V 368.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.88021,365.76042 -0.64063,0.16146 -0.64062,0.15625 -0.64063,0.48437 -0.47916,0.47917 -0.16146,0.79688 -0.15625,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 322.88021,365.59896 h 27.19791",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 352.80208,368.47917 -0.16146,-0.64062 -0.16145,-0.79688 L 352,366.5625 l -0.47917,-0.48437 -0.80208,-0.15625 -0.64063,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 352.95833,368.47917 v 35.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,-4.01333e-4 1.118541,-0.16186 2.238332,-0.641026 3.040416,-1.437901 3.681041,-2.401443 3.998749,-3.359776 v -1.28125 L 3.681041,-5.59936 3.040416,-6.557693 2.238332,-7.359776 1.118541,-7.838943 l -1.119792,-0.161458 -1.119792,0.161458 -1.119791,0.479167 -0.796875,0.802083 -0.640625,0.958333 -0.322917,0.958334 v 1.28125 l 0.322917,0.958333 0.640625,0.963542 0.796875,0.796875 1.119791,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,251.04,292.67999)",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 337.59896,383.19792 -5.76042,5.92188 m 0,-5.92188 5.76042,5.92188",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001251,0.00145967 0.800832,-0.159999 1.759166,-1.118332 1.920624,-1.920415 1.759166,-2.722499 0.800832,-3.680832 -0.001251,-3.84229 l -0.796875,0.161458 -0.484375,0.479167 -0.479167,0.479166 -0.15625,0.802084 0.15625,0.802083 0.479167,0.479167 0.484375,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,236.04,291.12)",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,0.00122633 H -35.038554 m -5.119791,0 h -5.28125 m -5.119792,0 h -5.28125 m -5.28125,0 h -25.916667 m -5.28125,0 h -5.28125 m -5.119786,0 h -5.28125 m -5.1198,0 h -26.07812 m -5.28125,0 h -5.28125 m -5.11979,0 h -5.27604",
    transform: "matrix(0.75,0,0,0.75,374.40001,390.96002)",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 333.92187,521.28125 H 298.88021 V 492.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,-6.04667e-4 V -5.281855 m 0,-5.276041 v -5.119792 m 0,-5.28125 v -26.083333 m 0,-5.119792 v -5.276042 m 0,-5.28125 v -5.119791 m 0,-5.28125 v -26.078125 m 0,-5.119789 v -5.28125 m 0,-5.11979 v -5.28125 m 0,-5.28125 v -26.07813 m 0,-5.11979 v -5.28125 m 0,-5.11979 v -5.28125 m 0,-5.27604 v -26.08334 m 0,-5.11979 v -5.28125 m 0,-5.11979 v -5.27604 m 0,-5.28125 v -25.92188 m 0,-5.27604 v -5.28125 m 0,-5.11979 v -5.28125 m 0,-5.11979 v -26.07813 m 0,-5.28125 v -5.28125 m 0,-5.11979 v -5.28125 m 0,-5.11979 v -26.07813 m 0,-5.28125 v -5.28125 m 0,-5.11979 v -5.27604 m 0,-5.125 v -26.07812 m 0,-5.28125 v -5.1198 m 0,-5.27604 v -5.28125",
    transform: "matrix(0.75,0,0,0.75,224.16,365.51999)",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 298.88021,49.281255 V 20.479172 h 35.04166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00165767,-8.28e-4 H 5.277699 m 5.119792,0 h 5.28125 m 5.28125,0 h 26.078125 m 5.119792,0 h 5.28125 m 5.119791,0 h 5.28125 m 5.28125,0 h 25.916667 m 5.281254,0 h 5.28125 m 5.11979,0 h 5.28125",
    transform: "matrix(0.75,0,0,0.75,254.28001,15.359996)",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 464.16146,20.479172 h 35.03646 v 28.802083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m -0.00209533,0.001045 v 5.28125 m 0,5.276042 v 5.119791 m 0,5.28125 v 26.078125 m 0,5.125 v 5.276042 m 0,5.119792 v 5.28125 m 0,5.28125 v 26.078125 m 0,5.119788 V 109.6 m 0,5.1198 v 5.28125 m 0,5.28125 v 26.07812 m 0,5.11979 v 5.28125 m 0,5.11979 v 5.28125 m 0,5.27604 v 25.92188 m 0,5.28125 v 5.27604 m 0,5.11979 v 5.28125 m 0,5.11979 v 26.08334 m 0,5.27604 v 5.28125 m 0,5.11979 v 5.28125 m 0,5.11979 v 26.07813 m 0,5.28125 v 5.28125 m 0,5.11979 v 5.28125 m 0,5.11979 v 26.07813 m 0,5.28125 v 5.11979 m 0,5.28125 v 5.27604 m 0,5.11979 v 26.08333 m 0,5.28125 v 5.1198 m 0,5.27604 v 5.28125",
    transform: "matrix(0.75,0,0,0.75,374.40001,40.799998)",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 499.19792,492.47917 v 28.80208",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path65"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.39844,15.359375 -0.11719,11.039063 V 15.359375 Z m 0,0",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.39844,15.359375 v 11.039063 h -0.11719 z m 0,0",
    id: "path67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.28125,26.160156 -1.67969,0.238282 v -0.238282 z m 0,0",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.28125,26.160156 v 0.238282 h -1.67969 z m 0,0",
    id: "path69"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 372.60156,24.839844 -0.24219,1.558594 v -1.558594 z m 0,0",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 372.60156,24.839844 v 1.558594 h -0.24219 z m 0,0",
    id: "path71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 366.83984,17.160156 -1.4414,0.121094 v -0.121094 z m 0,0",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 366.83984,17.160156 v 0.121094 h -1.4414 z m 0,0",
    id: "path73"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.28125,15.359375 -8.88281,0.121094 v -0.121094 z m 0,0",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.28125,15.359375 v 0.121094 h -8.88281 z m 0,0",
    id: "path75"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 365.39844,15.359375 -0.23828,1.921875 v -1.921875 z m 0,0",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 365.39844,15.359375 v 1.921875 h -0.23828 z m 0,0",
    id: "path77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,-8.28e-4 H 12.317912 m -12,0.161458 h 11.84375 m 0.15625,-0.161458 v 14.71875 M 12.161662,0.16063 v 14.239584 m 0.15625,0.317708 h -2.71875 m 2.5625,-0.317708 H 9.922078 m -0.322916,0.317708 v -2.078125 m 0.322916,1.760417 V 12.639797 M 2.03333e-4,-8.28e-4 v 2.5625 M 0.317912,0.16063 V 2.400214 M 2.03333e-4,2.561672 H 2.239787",
    transform: "matrix(0.75,0,0,0.75,365.16,15.359996)",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 487.19792,22.880214 h 1.92187 v 0.161458",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,-2.02e-4 H -0.320821 m -3.041667,-10.078125 v 0.958333 m 0,0.317709 v 0.963541 m 0,0.15625 v 1.125 m 0,0.15625 v 0.963542 m 0,0.317708 v 0.958334 m 0,0.161458 v 1.119792",
    transform: "matrix(0.75,0,0,0.75,372.59999,24.839995)",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 493.4375,30.401047 V 31.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,-2.02e-4 H 0.961243 m 0.15625,0 h 0.963542 m 0.317708,0 h 0.963542 m 0.15625,0 h 1.119791 m 0.161459,0 h 0.958333 m 0.322917,0 h 0.958333",
    transform: "matrix(0.75,0,0,0.75,366.24,24.839995)",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 495.68229,33.119797 h 0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.16016,15.359375 0.12109,11.039063 V 15.359375 Z m 0,0",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.16016,15.359375 v 11.039063 h 0.12109 z m 0,0",
    id: "path85"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.28125,26.160156 1.67969,0.238282 v -0.238282 z m 0,0",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.28125,26.160156 v 0.238282 h 1.67969 z m 0,0",
    id: "path87"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 225.96094,24.839844 0.23828,1.558594 v -1.558594 z m 0,0",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 225.96094,24.839844 v 1.558594 h 0.23828 z m 0,0",
    id: "path89"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 231.83984,17.160156 1.32032,0.121094 v -0.121094 z m 0,0",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 231.83984,17.160156 v 0.121094 h 1.32032 z m 0,0",
    id: "path91"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.28125,15.359375 8.87891,0.121094 v -0.121094 z m 0,0",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.28125,15.359375 v 0.121094 h 8.87891 z m 0,0",
    id: "path93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 233.16016,15.359375 0.23828,1.921875 v -1.921875 z m 0,0",
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 233.16016,15.359375 v 1.921875 h 0.23828 z m 0,0",
    id: "path95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-8.28e-4 H -12.319804 m 12,0.161458 h -11.838541 m -0.161459,-0.161458 v 14.71875 M -12.158345,0.16063 v 14.239584 m -0.161459,0.317708 h 2.71875 m -2.557291,-0.317708 h 2.239583 m 0.317708,0.317708 v -2.078125 m -0.317708,1.760417 V 12.639797 M -0.00209533,-8.28e-4 v 2.5625 M -0.319804,0.16063 v 2.239584 m 0.31770867,0.161458 H -2.08022",
    transform: "matrix(0.75,0,0,0.75,233.40001,15.359996)",
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.88021,22.880214 h -1.76042 v 0.161458",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0.001251,-2.02e-4 h 0.317708 m 3.041667,-10.078125 v 0.958333 m 0,0.317709 v 0.963541 m 0,0.15625 v 1.125 m 0,0.15625 v 0.963542 m 0,0.317708 v 0.958334 m 0,0.161458 v 1.119792",
    transform: "matrix(0.75,0,0,0.75,225.96,24.839995)",
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 304.64062,30.401047 V 31.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,-2.02e-4 H -0.801677 m -0.317708,0 h -0.958333 m -0.322917,0 h -0.958333 m -0.161459,0 h -1.119791 m -0.161459,0 H -5.76001 m -0.317708,0 H -7.04126",
    transform: "matrix(0.75,0,0,0.75,232.32001,24.839995)",
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 302.5625,33.119797 h -0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.39844,390.96094 -0.11719,-11.03907 v 11.03907 z m 0,0",
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.39844,390.96094 v -11.03907 h -0.11719 z m 0,0",
    id: "path103"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.28125,380.16016 -1.67969,-0.23829 v 0.23829 z m 0,0",
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.28125,380.16016 v -0.23829 h -1.67969 z m 0,0",
    id: "path105"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 372.60156,381.48047 -0.24219,-1.5586 v 1.5586 z m 0,0",
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 372.60156,381.48047 v -1.5586 h -0.24219 z m 0,0",
    id: "path107"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 366.83984,389.16016 -1.4414,-0.23829 v 0.23829 z m 0,0",
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 366.83984,389.16016 v -0.23829 h -1.4414 z m 0,0",
    id: "path109"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.28125,390.96094 -8.88281,-0.1211 v 0.1211 z m 0,0",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 374.28125,390.96094 v -0.1211 h -8.88281 z m 0,0",
    id: "path111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 365.39844,390.96094 -0.23828,-2.03907 v 2.03907 z m 0,0",
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 365.39844,390.96094 v -2.03907 h -0.23828 z m 0,0",
    id: "path113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 2.03333e-4,0.00122633 H 12.317912 m -12,-0.16145833 h 11.84375 m 0.15625,0.16145833 V -14.717524 m -0.15625,14.557292 v -14.239583 m 0.15625,-0.317709 h -2.71875 m 2.5625,0.317709 H 9.922078 m -0.322916,-0.317709 v 2.078125 m 0.322916,-1.760416 v 1.760416 M 2.03333e-4,0.00122633 V -2.717524 M 0.317912,-0.160232 V -2.399815 M 2.03333e-4,-2.717524 H 2.239787",
    transform: "matrix(0.75,0,0,0.75,365.16,390.96002)",
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 487.19792,518.88021 h 1.92187 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path115"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,6.15333e-4 H -0.320821 M -3.362488,9.92249 V 9.120407 m 0,-0.322917 V 7.839157 m 0,-0.161458 V 6.557907 m 0,-0.15625 V 5.438115 m 0,-0.317708 V 4.162074 m 0,-0.322917 V 2.880824",
    transform: "matrix(0.75,0,0,0.75,372.59999,381.48001)",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 493.4375,511.35938 v -0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00229867,6.15333e-4 H 0.961243 m 0.15625,0 h 0.963542 m 0.317708,0 h 0.963542 m 0.15625,0 h 1.119791 m 0.161459,0 h 0.958333 m 0.322917,0 h 0.958333",
    transform: "matrix(0.75,0,0,0.75,366.24,381.48001)",
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 495.68229,508.64063 h 0.79688",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path119"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.16016,390.96094 0.12109,-11.03907 v 11.03907 z m 0,0",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.16016,390.96094 v -11.03907 h 0.12109 z m 0,0",
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.28125,380.16016 1.67969,-0.23829 v 0.23829 z m 0,0",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.28125,380.16016 v -0.23829 h 1.67969 z m 0,0",
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 225.96094,381.48047 0.23828,-1.5586 v 1.5586 z m 0,0",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 225.96094,381.48047 v -1.5586 h 0.23828 z m 0,0",
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 231.83984,389.16016 1.32032,-0.23829 v 0.23829 z m 0,0",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 231.83984,389.16016 v -0.23829 h 1.32032 z m 0,0",
    id: "path127"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.28125,390.96094 8.87891,-0.1211 v 0.1211 z m 0,0",
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 224.28125,390.96094 v -0.1211 h 8.87891 z m 0,0",
    id: "path129"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 233.16016,390.96094 0.23828,-2.03907 v 2.03907 z m 0,0",
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000000",
    fillOpacity: 1,
    d: "m 233.16016,390.96094 v -2.03907 h 0.23828 z m 0,0",
    id: "path131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,0.00122633 H -12.319804 m 12,-0.16145833 h -11.838541 m -0.161459,0.16145833 V -14.717524 m 0.161459,14.557292 v -14.239583 m -0.161459,-0.317709 h 2.71875 m -2.557291,0.317709 h 2.239583 m 0.317708,-0.317709 v 2.078125 m -0.317708,-1.760416 v 1.760416 M -0.00209533,0.00122633 V -2.717524 M -0.319804,-0.160232 v -2.239583 m 0.31770867,-0.317709 H -2.08022",
    transform: "matrix(0.75,0,0,0.75,233.40001,390.96002)",
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 310.88021,518.88021 h -1.76042 v -0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.001251,6.15333e-4 H 0.318959 M 3.360626,9.92249 V 9.120407 m 0,-0.322917 V 7.839157 m 0,-0.161458 V 6.557907 m 0,-0.15625 V 5.438115 m 0,-0.317708 V 4.162074 m 0,-0.322917 V 2.880824",
    transform: "matrix(0.75,0,0,0.75,225.96,381.48001)",
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 304.64062,511.35938 v -0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 4.06667e-4,6.15333e-4 H -0.801677 m -0.317708,0 h -0.958333 m -0.322917,0 h -0.958333 m -0.161459,0 h -1.119791 m -0.161459,0 H -5.76001 m -0.317708,0 H -7.04126",
    transform: "matrix(0.75,0,0,0.75,232.32001,381.48001)",
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 302.5625,508.64063 h -0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 402.07812,118.88021 V 217.4375 H 396 v -98.55729 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,2.16667e-4 -0.642487,-0.640408 l -0.635417,-0.479167 -0.802083,-0.322917 -0.958333,-0.15625 -0.963542,0.15625 -0.796875,0.322917 -0.640625,0.479167 -0.640625,0.640624667",
    transform: "matrix(0.75,0,0,0.75,301.55999,89.159994)",
    id: "path139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0,-0.00104233 0.640625,0.639583 1.28125,1.118749 2.078125,1.441666 3.041667,1.597916 4,1.441666 4.802083,1.118749 5.4375,0.639583 6.078125,-0.00104233",
    transform: "matrix(0.75,0,0,0.75,297,163.2)",
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 399.04167,118.88021 V 217.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path141"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g141"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 302.87909,
    y: 112.20049,
    id: "use141"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 5659.4021,-15015.567 c 9.2251,4.228 13.8376,13.453 13.8376,27.675 0,4.228 -0.7687,8.264 -2.3062,12.3 l -5.3813,20.757 c -6.1501,23.639 -18.4502,39.206 -36.9004,46.894 -9.2251,4.228 -19.9877,6.15 -32.2878,6.15 h -40.7442 c -6.7266,0 -9.9938,-3.46 -9.9938,-10.763 0,-6.534 3.2672,-9.994 9.9938,-9.994 h 46.8942 c 9.2251,0 17.6815,-3.075 25.369,-9.225 8.072,-6.15 13.4533,-13.837 16.144,-23.062 l 5.3813,-20.757 c 0.9609,-4.612 1.5375,-8.648 1.5375,-12.3 0,-12.685 -8.8407,-19.219 -26.1378,-19.219 h -18.4502 c -7.3032,0 -10.7626,-3.459 -10.7626,-10.763 0,-7.111 3.4594,-10.762 10.7626,-10.762 h 24.6003 c 12.6845,0 23.4471,-4.997 32.2878,-15.375 4.6125,-4.997 7.6876,-10.379 9.2251,-16.144 0.3844,-3.46 0.7687,-6.535 0.7687,-9.225 0,-14.799 -8.4563,-22.294 -25.369,-22.294 h -40.7441 c -7.3032,0 -10.7626,-3.46 -10.7626,-10.763 0,-7.111 3.4594,-10.763 10.7626,-10.763 h 46.1254 c 16.3361,0 28.6363,7.496 36.9004,22.294 3.075,6.727 4.6126,13.646 4.6126,20.757 0,3.075 -0.3844,6.534 -0.7688,9.994 -6.1501,23.062 -17.6814,38.053 -34.5941,44.588 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path142"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g142"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 302.87909,
    y: 115.32047,
    id: "use142"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 5756.0734,-14922.548 c 21.5252,0 34.9785,-10.762 40.7441,-32.287 l 6.1501,-20.757 c 0.9609,-4.036 1.5375,-8.072 1.5375,-12.3 0,-12.685 -8.8407,-19.219 -26.1377,-19.219 h -33.0566 l -13.8377,52.276 c -1.1531,3.651 -1.5375,6.534 -1.5375,8.456 0,6.726 2.3063,12.3 6.9188,16.913 4.997,4.612 11.5314,6.918 19.219,6.918 z m -6.1501,20.757 c -14.9908,0 -26.7143,-7.688 -35.3628,-23.063 -4.2282,-6.534 -6.1501,-13.453 -6.1501,-20.756 0,-3.075 0.3844,-5.766 1.5375,-8.457 l 16.9127,-63.807 c 6.1501,-23.447 16.5283,-43.242 31.5191,-59.194 16.3361,-17.297 37.8613,-29.213 64.5756,-35.363 0.9609,-0.384 1.9219,-0.769 3.075,-0.769 6.5345,0 9.9939,3.652 9.9939,10.763 0,6.15 -2.3063,9.61 -6.9188,9.994 -11.9158,1.537 -23.6393,5.958 -35.3629,13.069 -21.5252,13.453 -35.1707,30.366 -40.7441,50.738 h 31.519 c 11.7236,0 21.5252,3.844 29.2128,11.531 8.072,7.688 12.3001,17.682 12.3001,29.982 0,4.228 -0.5765,8.072 -1.5375,11.531 l -5.3813,20.757 c -6.7266,24.6 -18.8345,40.551 -36.1316,47.662 -8.8407,3.652 -19.7955,5.382 -33.0566,5.382 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path143"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g143"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 302.87909,
    y: 118.32043,
    id: "use143"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 5970.5568,-15005.573 -60.7319,99.169 c -2.1141,3.075 -5.1891,4.613 -9.2251,4.613 -3.075,0 -5.7657,-0.961 -7.6875,-3.075 -2.1141,-2.499 -3.0751,-4.997 -3.0751,-7.688 l 7.6876,-189.883 c 0,-7.111 3.2672,-10.763 9.9938,-10.763 7.6876,0 11.5314,3.844 11.5314,11.532 l -6.9188,149.908 57.6568,-93.02 c 1.5375,-3.075 4.2282,-4.613 8.4564,-4.613 6.5344,0 10.186,3.075 10.7626,9.225 l 6.9188,89.945 77.6445,-156.827 c 1.9219,-4.035 4.9969,-6.15 9.2251,-6.15 7.111,0 10.7626,3.652 10.7626,10.763 0,1.538 -0.3844,3.075 -0.7688,4.613 l -94.5571,190.651 c -2.1141,3.652 -5.1892,5.382 -9.2251,5.382 -7.3032,0 -10.7626,-3.267 -10.7626,-9.994 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path144"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g144"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 302.99899,
    y: 127.31905,
    id: "use144"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6387.2234,-14928.506 c 7.1111,0 10.7627,3.46 10.7627,9.994 0,7.304 -3.6516,10.763 -10.7627,10.763 h -89.9446 c -3.075,0 -5.7657,-0.961 -7.6876,-3.075 -1.5375,-1.922 -1.9219,-4.613 -0.7687,-7.688 l 51.5067,-192.958 c 1.5375,-4.997 4.9969,-7.687 10.7626,-7.687 6.5345,0 9.9939,3.651 9.9939,10.762 0,1.153 0,2.114 0,3.075 l -47.663,176.814 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path145"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g145"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 302.99899,
    y: 130.43903,
    id: "use145"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6547.5094,-15013.069 h -57.6568 l -23.0627,84.563 h 73.8007 c 7.111,0 10.7626,3.46 10.7626,9.994 0,7.304 -3.6516,10.763 -10.7626,10.763 h -89.9446 c -3.0751,0 -5.7657,-0.961 -7.6876,-3.075 -1.5375,-1.922 -1.9219,-4.613 -0.7688,-7.688 l 50.738,-189.883 c 1.9219,-7.111 6.9188,-10.762 14.6064,-10.762 h 83.7946 c 7.111,0 10.7626,3.651 10.7626,10.762 0,7.303 -3.6516,10.763 -10.7626,10.763 h -79.182 l -16.9127,63.038 h 52.2755 c 6.5345,0 9.9939,3.652 9.9939,10.763 0,7.303 -3.4594,10.762 -9.9939,10.762 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path146"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g146"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 302.99899,
    y: 133.439,
    id: "use146"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 6640.5291,-15108.395 c 1.9219,-7.111 6.9188,-10.762 14.6064,-10.762 h 65.3444 c 10.7626,0 20.1799,4.612 28.444,13.837 8.6486,9.225 13.0689,19.604 13.0689,30.751 0,3.075 -0.3844,5.957 -0.7687,8.456 l -28.4441,105.32 c -9.8016,35.362 -32.8644,53.044 -69.1882,53.044 h -65.3444 c -3.075,0 -5.7657,-0.961 -7.6875,-3.075 -1.5376,-1.922 -1.9219,-4.613 -0.7688,-7.688 z m 19.2189,10.763 -45.3567,169.126 h 54.5818 c 9.2251,0 17.6815,-3.075 25.369,-9.225 8.072,-6.15 13.4533,-13.837 16.144,-23.062 l 28.444,-105.32 c 0.3844,-2.499 0.7687,-4.997 0.7687,-7.688 0,-7.111 -2.3062,-12.684 -6.9188,-16.912 -4.6125,-4.613 -10.7626,-6.919 -18.4502,-6.919 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 409.92187,169.76042 v 14.71875 h -6.23958 v -14.71875 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 402.07812,370.23959 v 98.5625 H 396 v -98.5625 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path149"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,-4.01333e-4 -0.642487,-0.641026 -1.277904,-1.120193 -2.079987,-1.437901 -3.03832,-1.59936 l -0.963542,0.161459 -0.796875,0.317708 -0.640625,0.479167 -0.640625,0.640624667",
    transform: "matrix(0.75,0,0,0.75,301.55999,277.67999)",
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0,0.00210067 0.640625,0.637517 1.28125,1.121892 2.078125,1.439601 3.041667,1.601059 4,1.439601 4.802083,1.121892 5.4375,0.637517 6.078125,0.00210067",
    transform: "matrix(0.75,0,0,0.75,297,351.59999)",
    id: "path151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 399.04167,370.23959 v 98.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path152"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g152"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-0",
    x: 302.87909,
    y: 300.71652,
    id: "use152"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 14934.464,-15015.567 c 9.225,4.228 13.837,13.453 13.837,27.675 0,4.228 -0.769,8.264 -2.306,12.3 l -5.381,20.757 c -6.15,23.639 -18.451,39.206 -36.901,46.894 -9.225,4.228 -19.987,6.15 -32.288,6.15 h -40.744 c -6.726,0 -9.994,-3.46 -9.994,-10.763 0,-6.534 3.268,-9.994 9.994,-9.994 h 46.895 c 9.225,0 17.681,-3.075 25.369,-9.225 8.071,-6.15 13.453,-13.837 16.143,-23.062 l 5.382,-20.757 c 0.961,-4.612 1.537,-8.648 1.537,-12.3 0,-12.685 -8.84,-19.219 -26.137,-19.219 h -18.451 c -7.303,0 -10.762,-3.459 -10.762,-10.763 0,-7.111 3.459,-10.762 10.762,-10.762 h 24.601 c 12.684,0 23.447,-4.997 32.287,-15.375 4.613,-4.997 7.688,-10.379 9.225,-16.144 0.385,-3.46 0.769,-6.535 0.769,-9.225 0,-14.799 -8.456,-22.294 -25.369,-22.294 h -40.744 c -7.303,0 -10.763,-3.46 -10.763,-10.763 0,-7.111 3.46,-10.763 10.763,-10.763 h 46.126 c 16.336,0 28.636,7.496 36.9,22.294 3.075,6.727 4.612,13.646 4.612,20.757 0,3.075 -0.384,6.534 -0.768,9.994 -6.15,23.062 -17.682,38.053 -34.594,44.588 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path153"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g153"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-1",
    x: 302.87909,
    y: 303.83649,
    id: "use153"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15031.135,-14922.548 c 21.525,0 34.978,-10.762 40.744,-32.287 l 6.15,-20.757 c 0.961,-4.036 1.538,-8.072 1.538,-12.3 0,-12.685 -8.841,-19.219 -26.138,-19.219 h -33.057 l -13.837,52.276 c -1.153,3.651 -1.538,6.534 -1.538,8.456 0,6.726 2.306,12.3 6.919,16.913 4.997,4.612 11.531,6.918 19.219,6.918 z m -6.15,20.757 c -14.991,0 -26.715,-7.688 -35.363,-23.063 -4.228,-6.534 -6.15,-13.453 -6.15,-20.756 0,-3.075 0.384,-5.766 1.537,-8.457 l 16.913,-63.807 c 6.15,-23.447 16.528,-43.242 31.519,-59.194 16.336,-17.297 37.861,-29.213 64.576,-35.363 0.961,-0.384 1.922,-0.769 3.075,-0.769 6.534,0 9.994,3.652 9.994,10.763 0,6.15 -2.307,9.61 -6.919,9.994 -11.916,1.537 -23.639,5.958 -35.363,13.069 -21.525,13.453 -35.171,30.366 -40.744,50.738 h 31.519 c 11.723,0 21.525,3.844 29.213,11.531 8.072,7.688 12.3,17.682 12.3,29.982 0,4.228 -0.577,8.072 -1.538,11.531 l -5.381,20.757 c -6.727,24.6 -18.835,40.551 -36.132,47.662 -8.84,3.652 -19.795,5.382 -33.056,5.382 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path154"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g154"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-2",
    x: 302.87909,
    y: 306.83646,
    id: "use154"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15245.618,-15005.573 -60.732,99.169 c -2.114,3.075 -5.189,4.613 -9.225,4.613 -3.075,0 -5.765,-0.961 -7.687,-3.075 -2.114,-2.499 -3.075,-4.997 -3.075,-7.688 l 7.687,-189.883 c 0,-7.111 3.268,-10.763 9.994,-10.763 7.688,0 11.532,3.844 11.532,11.532 l -6.919,149.908 57.657,-93.02 c 1.537,-3.075 4.228,-4.613 8.456,-4.613 6.534,0 10.186,3.075 10.762,9.225 l 6.919,89.945 77.645,-156.827 c 1.922,-4.035 4.997,-6.15 9.225,-6.15 7.111,0 10.763,3.652 10.763,10.763 0,1.538 -0.385,3.075 -0.769,4.613 l -94.557,190.651 c -2.115,3.652 -5.19,5.382 -9.226,5.382 -7.303,0 -10.762,-3.267 -10.762,-9.994 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path155"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g155"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-3",
    x: 302.99899,
    y: 315.83832,
    id: "use155"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15662.477,-14928.506 c 7.111,0 10.763,3.46 10.763,9.994 0,7.304 -3.652,10.763 -10.763,10.763 h -89.945 c -3.075,0 -5.765,-0.961 -7.687,-3.075 -1.538,-1.922 -1.922,-4.613 -0.769,-7.688 l 51.507,-192.958 c 1.537,-4.997 4.997,-7.687 10.763,-7.687 6.534,0 9.993,3.651 9.993,10.762 0,1.153 0,2.114 0,3.075 l -47.663,176.814 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path156"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g156"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-4",
    x: 302.99899,
    y: 318.95828,
    id: "use156"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15822.763,-15013.069 h -57.657 l -23.062,84.563 h 73.8 c 7.111,0 10.763,3.46 10.763,9.994 0,7.304 -3.652,10.763 -10.763,10.763 h -89.944 c -3.075,0 -5.766,-0.961 -7.688,-3.075 -1.537,-1.922 -1.922,-4.613 -0.769,-7.688 l 50.738,-189.883 c 1.922,-7.111 6.919,-10.762 14.607,-10.762 h 83.794 c 7.111,0 10.763,3.651 10.763,10.762 0,7.303 -3.652,10.763 -10.763,10.763 h -79.182 l -16.912,63.038 h 52.275 c 6.535,0 9.994,3.652 9.994,10.763 0,7.303 -3.459,10.762 -9.994,10.762 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path157"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g157"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-0-5",
    x: 302.99899,
    y: 321.95825,
    id: "use157"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2.952,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 15915.783,-15108.395 c 1.922,-7.111 6.919,-10.762 14.606,-10.762 h 65.345 c 10.762,0 20.179,4.612 28.444,13.837 8.648,9.225 13.069,19.604 13.069,30.751 0,3.075 -0.385,5.957 -0.769,8.456 l -28.444,105.32 c -9.802,35.362 -32.865,53.044 -69.188,53.044 h -65.345 c -3.075,0 -5.766,-0.961 -7.687,-3.075 -1.538,-1.922 -1.922,-4.613 -0.769,-7.688 z m 19.219,10.763 -45.357,169.126 h 54.582 c 9.225,0 17.681,-3.075 25.369,-9.225 8.072,-6.15 13.453,-13.837 16.144,-23.062 l 28.444,-105.32 c 0.384,-2.499 0.769,-4.997 0.769,-7.688 0,-7.111 -2.307,-12.684 -6.919,-16.912 -4.613,-4.613 -10.763,-6.919 -18.45,-6.919 z m 0,0",
    transform: "matrix(0,0.020325,-0.020325,0,0,-4e-6)",
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 409.92187,421.1198 v 14.71875 h -6.23958 V 421.1198 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path159"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 0,-0.00185667 2.880208,-0.15625033 2.880209,-0.484375 2.71875,-0.958333 2.5625,-1.28125 2.395833,-1.4375 2.244792,-1.921875 1.916666,-2.078125 1.760417,-2.239583 1.28125,-2.5625 1.119792,-2.71875 0.640625,-2.71875 0.479166,-2.880209 v -2.880208 l -0.479166,-2.880208 -0.640625,-2.71875 -1.119792,-2.723959 -1.28125,-2.557291 -1.760417,-2.239584 -1.916666,-2.078125 -2.244792,-1.921875 -2.395833,-1.442708 -2.5625,-1.276042 -2.71875,-0.963541 L 2.880208,-45.600815 0,-45.762273 l -2.880208,0.161458 -2.880209,0.479167 -2.71875,0.963541 -2.5625,1.276042 -2.395833,1.442708 -2.244792,1.921875 -1.916666,2.078125 -1.760417,2.239584 -1.28125,2.557291 -1.119792,2.723959 -0.640625,2.71875 -0.479166,2.880208 v 2.880208 l 0.479166,2.880209 0.640625,2.71875 1.119792,2.71875 1.28125,2.5625 1.760417,2.239583 1.916666,2.078125 2.244792,1.921875 2.395833,1.4375 2.5625,1.28125 2.71875,0.958333 2.880209,0.484375 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,342,373.55999)",
    id: "path160"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g160"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-0",
    x: 338.87659,
    y: 347.63834,
    id: "use160"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g161"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 338.87659,
    y: 352.47668,
    id: "use161"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g162"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-1",
    x: 338.87659,
    y: 357.22867,
    id: "use162"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1,
    id: "g163"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph-1-2",
    x: 338.87659,
    y: 362.06702,
    id: "use163"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.5625,81.437505 h 5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.83854,81.437505 0.64063,0.802084 0.80208,0.640625 0.95833,0.317708 0.95834,0.161458",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.19792,83.35938 h 8.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 483.35937,83.35938 0.95834,-0.161458 1.11979,-0.317708 0.80208,-0.640625 0.64063,-0.958334 0.31771,-0.963541 0.16145,-0.958334",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 487.52083,79.35938 V 54.718755",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 487.35937,54.718755 -0.16145,-0.958333 -0.31771,-1.119792 -0.64063,-0.802083 -0.80208,-0.640625 -1.11979,-0.317708 -0.95834,-0.161459",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 483.35937,50.562505 h -8.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.19792,50.718755 -0.95834,0.161459 -0.95833,0.317708 -0.80208,0.640625 -0.64063,0.802083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 471.68229,52.64063 H 466.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path171"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.5625,52.64063 -1.125,-0.322916 -0.95833,-0.317709",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 464.47917,51.838547 -2.40105,-0.479167 -2.39583,-0.479166 -2.5625,-0.161459 -2.40104,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.71875,50.562505 -2.40104,0.15625 -2.55729,0.161459 -4.80209,0.958333",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.80208,52.000005 -1.92187,0.640625 -2.07813,0.796875 -1.76041,0.963542 -1.92188,1.119792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 437.28125,55.520839 -1.59896,1.119791 -1.44271,1.4375 -1.28125,1.442709 -1.11979,1.598958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 431.68229,61.281255 -0.64062,1.28125 -0.47917,1.4375 -0.32292,1.4375 -0.16146,1.604167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 430.07812,67.041672 0.16146,1.598958 0.32292,1.4375 0.47917,1.442709 0.64062,1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 431.83854,72.958339 1.11979,1.604166 1.28125,1.4375 1.44271,1.4375 1.59896,1.125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 437.11979,78.562505 1.92188,1.119792 1.76041,0.958333 2.07813,0.796875 1.92187,0.640625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.95833,82.07813 2.40104,0.484375 2.40105,0.479167 2.55729,0.15625 2.40104,0.161458",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path181"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.71875,83.35938 2.40104,-0.161458 2.5625,-0.15625 2.39583,-0.479167 2.40105,-0.484375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 464.47917,82.07813 0.95833,-0.317708 1.125,-0.322917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path183"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 470.88021,59.838547 -0.47917,-0.479167 -0.80208,-0.479166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.76042,58.880214 -1.44271,-0.802084 -1.59896,-0.796875 -1.59896,-0.802083 -1.76042,-0.479167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path185"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 463.35937,55.838547 -2.07812,-0.479167 -2.23958,-0.317708 -2.08334,-0.322917 h -2.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.71875,54.718755 h -2.23958 l -2.07813,0.322917 -2.23958,0.317708 -2.08334,0.479167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path187"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 445.92187,56.000005 -1.76041,0.479167 -1.59896,0.802083 -1.60417,0.796875 -1.4375,0.802084",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 439.68229,58.880214 -1.28125,0.958333 -2.23958,2.239583 -0.80209,1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path189"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 435.19792,63.35938 -0.47917,0.802084 -0.31771,0.958333 -0.32292,0.958333 v 0.963542",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 434.07812,67.041672 v 0.958333 l 0.32292,0.958334 0.31771,0.963541 0.47917,0.796875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 435.35937,70.718755 0.80209,1.28125 2.23958,2.239584 1.28125,0.958333",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 439.52083,75.197922 1.4375,0.802083 1.60417,0.802084 1.59896,0.796875 1.76041,0.479166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path193"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 446.07812,78.07813 2.08334,0.484375 2.23958,0.317709 2.07813,0.317708 h 2.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.71875,79.197922 h 2.23958 l 2.08334,-0.317708 2.23958,-0.317709 2.07812,-0.484375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 463.35937,78.07813 1.76042,-0.479166 1.59896,-0.796875 1.59896,-0.802084 1.44271,-0.802083",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.59896,75.197922 0.80208,-0.479167 0.47917,-0.479166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.19792,52.000005 -0.63542,0.161459 -0.64063,0.15625 -0.64062,0.484375 -0.47917,0.479166 -0.16146,0.796875 -0.16145,0.640625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.19792,51.838547 h 8.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 486.07812,54.718755 -0.15625,-0.640625 -0.16145,-0.796875 -0.47917,-0.479166 -0.47917,-0.484375 L 484,52.161464 483.35937,52.000005",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 486.23958,54.718755 V 79.35938",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 483.35937,82.07813 484,81.92188 l 0.80208,-0.161458 0.47917,-0.479167 0.47917,-0.640625 0.16145,-0.640625 0.15625,-0.640625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 483.35937,82.239589 h -8.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 472.47917,79.35938 0.32291,1.28125 0.47917,0.640625 0.64062,0.479167 0.64063,0.161458 0.63542,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 472.31771,79.35938 V 54.718755",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.19792,79.35938 v 0.479167 l 0.16145,0.640625 0.16146,0.479167 0.31771,0.479166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 471.04167,79.35938 V 54.718755",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.83854,52.64063 -0.31771,0.479167 -0.16146,0.479167 -0.16145,0.640625 v 0.479166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,-4.09333e-4 1.279388,-1.120201 2.39918,-2.401451 3.201263,-3.838951 3.68043,-5.437909 3.841888,-7.198326 3.68043,-8.958743 3.201263,-10.557701 2.39918,-12.000409 l -1.119792,-1.28125 -1.28125,-1.119792",
    transform: "matrix(0.75,0,0,0.75,328.55999,55.679995)",
    id: "path209"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00103433 -0.637512,0.160424 -1.121887,0.478132 -1.439595,1.118757 v 0.640625 l 0.317708,0.640625 0.484375,0.317709 0.63541667,0.161458 L 0.63853,2.717716 1.117696,2.400007 1.440613,1.759382 V 1.118757 L 1.117696,0.478132 0.63853,0.160424 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,359.40001,49.199995)",
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 390.23958,102.40105 h 97.28125 v 1.4375 l -97.28125,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 388.95833,103.6823 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 388.95833,36.802089 V 31.35938 h 1.28125 v 6.71875",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 390.23958,95.682297 v 6.718753 m -1.28125,0 v -6.718753",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 390.23958,38.07813 h -58.71875 v -1.276041 h 57.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path215"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.44333e-4,-0.00187167 0.162303,4.638753 0.797719,9.11792 l 0.802084,4.484375 1.28125,4.317708 1.598958,4.317709 1.921875,4.161458 2.239583,4 2.71875,3.838542 2.71875,3.520833 3.203125,3.359375 3.359375,3.041667 3.677084,2.71875 3.84375,2.5625 4,2.078125 4.15625,1.921875 4.322916,1.4375 4.479167,1.28125 4.479167,0.802083 4.640625,0.317708 4.479166,0.161459",
    transform: "matrix(0.75,0,0,0.75,248.63999,28.559998)",
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.5625,153.92188 h 5.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.83854,153.92188 0.64063,0.79687 0.80208,0.64063 0.95833,0.32292 0.95834,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.19792,155.83855 h 8.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 483.35937,155.83855 0.95834,-0.15625 1.11979,-0.32292 0.80208,-0.64063 0.64063,-0.95833 0.31771,-0.95833 0.16145,-0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 487.52083,151.83855 V 127.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path221"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 487.35937,127.19792 -0.16145,-0.95833 -0.31771,-1.11979 -0.64063,-0.80209 -0.80208,-0.63541 -1.11979,-0.32292 -0.95834,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 483.35937,123.04167 h -8.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.19792,123.19792 -0.95834,0.16146 -0.95833,0.32292 -0.80208,0.63541 -0.64063,0.80209",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 471.68229,124.95834 H 466.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 466.5625,124.95834 -1.125,-0.31771 -0.95833,-0.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 464.47917,124.31771 -2.40105,-0.47916 -2.39583,-0.47917 -2.5625,-0.16146 -2.40104,-0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.71875,123.04167 -2.40104,0.15625 -2.55729,0.16146 -4.80209,0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.80208,124.31771 -1.92187,0.64063 -2.07813,0.80208 -1.76041,0.95834 -1.92188,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path229"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 437.28125,128 -1.59896,1.1198 -1.44271,1.4427 -1.28125,1.4375 -1.11979,1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 431.68229,133.76042 -0.64062,1.28125 -0.47917,1.4375 -0.32292,1.44271 -0.16146,1.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 430.07812,139.52084 0.16146,1.59896 0.32292,1.4427 0.47917,1.4375 0.64062,1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 431.83854,145.28125 1.11979,1.59896 1.28125,1.4375 1.44271,1.44271 1.59896,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 437.11979,151.04167 1.92188,1.11979 1.76041,0.95834 2.07813,0.80208 1.92187,0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 444.95833,154.5625 4.80209,0.95834 2.55729,0.16146 2.40104,0.15625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.71875,155.83855 2.40104,-0.15625 2.5625,-0.16146 2.39583,-0.47917 2.40105,-0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 464.47917,154.5625 0.95833,-0.32291 1.125,-0.31771",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 470.88021,132.31771 -0.47917,-0.47916 -0.80208,-0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.76042,131.19792 -1.44271,-0.79687 -1.59896,-0.80209 -1.59896,-0.79687 -1.76042,-0.48438",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path239"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 463.35937,128.31771 -2.07812,-0.47916 -2.23958,-0.31771 -2.08334,-0.32292 h -2.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.71875,127.19792 h -2.23958 l -2.07813,0.32292 -2.23958,0.31771 -2.08334,0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path241"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 445.92187,128.31771 -1.76041,0.48438 -1.59896,0.79687 -1.60417,0.80209 -1.4375,0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 439.68229,131.35938 -1.28125,0.95833 -1.11979,1.11979 -1.11979,1.125 -0.80209,1.27605",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 435.19792,135.83855 -0.47917,0.80208 -0.31771,0.95833 -0.32292,0.96354 v 0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 434.07812,139.52084 v 0.95833 l 0.32292,0.95833 0.31771,0.96355 0.47917,0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 435.35937,143.04167 0.80209,1.27604 1.11979,1.11979 1.11979,1.125 1.28125,0.95834",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 439.52083,147.6823 1.4375,0.79687 1.60417,0.80208 1.59896,0.79688 1.76041,0.48437",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path247"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 446.07812,150.5625 2.08334,0.47917 2.23958,0.31771 2.07813,0.32292 h 2.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.71875,151.6823 h 2.23958 l 2.08334,-0.32292 2.23958,-0.31771 2.07812,-0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 463.35937,150.5625 1.76042,-0.48437 1.59896,-0.79688 1.59896,-0.80208 1.44271,-0.79687",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 469.59896,147.52084 0.80208,-0.47917 0.47917,-0.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path251"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.19792,124.47917 -0.63542,0.16146 -0.64063,0.16146 -0.64062,0.47917 -0.47917,0.47916 -0.16146,0.80209 -0.16145,0.63541",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 475.19792,124.31771 h 8.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 486.07812,127.19792 -0.15625,-0.63541 -0.16145,-0.80209 -0.95834,-0.95833 -0.80208,-0.16146 -0.64063,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 486.23958,127.19792 v 24.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path255"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 483.35937,154.5625 484,154.40105 l 0.80208,-0.16146 0.47917,-0.47917 0.47917,-0.64062 0.16145,-0.64063 0.15625,-0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 483.35937,154.5625 h -8.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 472.47917,151.83855 0.32291,1.28125 0.47917,0.64062 0.64062,0.47917 0.64063,0.16146 0.63542,0.16145",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 472.31771,151.83855 V 127.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.19792,151.83855 v 0.47916 l 0.16145,0.64063 0.16146,0.47916 0.31771,0.48438",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 471.04167,151.83855 V 127.19792",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 471.83854,125.1198 -0.31771,0.47916 -0.16146,0.47917 -0.16145,0.64063 v 0.47916",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001862,-0.00124567 1.279388,-1.121037 2.39918,-2.402287 3.201263,-3.839787 3.68043,-5.438746 3.841888,-7.199162 3.68043,-8.959579 3.201263,-10.558537 2.39918,-12.001246 l -1.119792,-1.28125 -1.28125,-1.119791",
    transform: "matrix(0.75,0,0,0.75,328.55999,110.04)",
    id: "path263"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00209533,-0.00187167 -0.637512,0.159587 -1.121887,0.482503 -1.439595,1.11792 v 0.640625 l 0.317708,0.640625 0.484375,0.322917 0.63541667,0.15625 L 0.63853,2.722087 1.117696,2.39917 1.440613,1.758545 V 1.11792 L 1.117696,0.482503 0.63853,0.159587 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,359.40001,103.56)",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 390.23958,174.88021 h 97.28125 v 1.28125 h -98.5625 v -1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00165767,0.00125633 V -5.597702 m 1.28124967,0 v 6.880208 m 0,57.4375 v 6.880209 m -1.28124967,0 v -6.880209",
    transform: "matrix(0.75,0,0,0.75,291.71999,81.959995)",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 390.23958,110.56251 h -58.71875 v -1.28125 h 57.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 8.44333e-4,0.00250733 0.162303,4.637924 l 0.635416,4.484375 0.802084,4.479167 1.28125,4.317708 1.598958,4.322917 1.921875,4.15625 2.239583,4 2.71875,3.84375 2.71875,3.515625 3.203125,3.364583 3.359375,3.036458 3.677084,2.71875 3.84375,2.5625 4,2.078125 4.15625,1.921875 4.322916,1.4375 4.479167,1.28125 4.479167,0.802084 4.640625,0.317708 4.479166,0.161458",
    transform: "matrix(0.75,0,0,0.75,248.63999,82.919995)",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 430.07812,245.59896 v -1.28125 h 57.44271 v 1.28125 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 481.11979,222.88021 V 197.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 465.11979,213.76042 3.68229,5.76042 4.47917,5.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 467.52083,212.31771 2.55729,4.16146 3.04167,4 3.35938,3.68229",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 487.52083,229.28125 v -38.5625 h -15.04166",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 481.11979,197.28125 -8.64062,-2.23958",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 467.35937,208 -0.3177,0.95834 -0.16146,1.11979 0.16146,1.11979 0.3177,0.96354",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path275"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 465.11979,206.40105 -0.47917,1.11979 -0.32291,1.28125 -0.15625,1.27604 0.15625,1.28125 0.32291,1.28125 0.47917,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 472.47917,195.04167 v -4.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 473.28125,195.19792 -4.47917,5.28125 -3.68229,5.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,0.00145967 0.801239,-0.159999 1.441864,-0.639165 1.921031,-1.27979 2.082489,-2.081874 1.921031,-2.878749 1.441864,-3.519374 0.801239,-3.99854 -8.44333e-4,-4.159999 -0.797719,-3.99854 l -0.640625,0.479166 -0.479167,0.640625 -0.161458,0.796875 0.161458,0.802084 0.479167,0.640625 0.640625,0.479166 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,354.36001,159.12)",
    id: "path279"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 476.47917,195.83855 -3.35938,3.68229 -3.04167,4 -2.55729,4.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 487.52083,229.28125 H 472.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path281"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 481.11979,222.88021 -8.64062,2.07813 v 4.32291",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 430.07812,311.19792 v -1.27604 h 57.44271 v 1.27604 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 481.11979,288.47917 V 262.88021",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 465.11979,279.35938 3.68229,5.76042 4.47917,5.4427",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 467.52083,278.07813 2.55729,4.16146 3.04167,4 3.35938,3.68229",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 487.52083,294.88021 V 256.47917 H 472.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 481.11979,262.88021 -8.64062,-2.07812",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 467.35937,273.59896 -0.3177,0.96354 -0.16146,1.1198 0.16146,1.11979 0.3177,0.95833",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path289"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 465.11979,272 -0.47917,1.1198 -0.32291,1.28125 -0.15625,1.28125 0.15625,1.27604 0.32291,1.28125 0.47917,1.11979",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 472.47917,260.80209 v -4.32292",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 473.28125,260.95834 -4.47917,5.28125 L 465.11979,272",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -8.44333e-4,4.12e-4 0.801239,-0.161046 1.441864,-0.640213 1.921031,-1.280838 2.082489,-2.077713 1.921031,-2.879796 1.441864,-3.520421 0.801239,-3.999588 -8.44333e-4,-4.161046 -0.797719,-3.999588 l -0.640625,0.479167 -0.479167,0.640625 -0.161458,0.802083 0.161458,0.796875 0.479167,0.640625 0.640625,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,354.36001,208.32)",
    id: "path293"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 476.47917,261.59896 -3.35938,3.68229 -3.04167,3.83855 -2.55729,4.3177",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 487.52083,294.88021 H 472.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path295"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 481.11979,288.47917 -8.64062,2.23958 v 4.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 422.5625,446.5625 v 1.27605 h 65.75521 V 382.07813 H 422.5625 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 422.5625,446.5625 h 61.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 484.16146,446.40105 0.64062,-0.16146 0.79688,-0.16146 0.47916,-0.47917 0.48438,-0.64062 0.15625,-0.64063 0.16146,-0.63541",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 487.04167,443.6823 V 386.23959",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 486.88021,386.23959 -0.16146,-0.64063 -0.15625,-0.79687 -0.96354,-0.96354 -0.79688,-0.15625 -0.64062,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 484.16146,383.35938 H 422.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.00250733 0.799377,-0.481868 1.278544,-1.278743 1.60146,-2.080826 1.75771,-3.039159 1.60146,-3.997493 1.278544,-4.799576 0.799377,-5.601659 0.002502,-6.080826",
    transform: "matrix(0.75,0,0,0.75,316.92,334.91999)",
    id: "path303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.00145967 0.799377,-0.477707 1.278544,-1.27979 1.60146,-2.081874 1.75771,-3.040207 1.60146,-3.99854 1.278544,-4.800624 0.799377,-5.597499 0.002502,-6.081874",
    transform: "matrix(0.75,0,0,0.75,316.92,330.12)",
    id: "path304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.00186733 0.799377,-0.482508 1.278544,-1.279383 1.60146,-2.081466 1.75771,-3.039799 1.60146,-3.998133 1.278544,-4.800216 0.799377,-5.602299 0.002502,-6.081466",
    transform: "matrix(0.75,0,0,0.75,316.92,325.44001)",
    id: "path305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,8.49667e-4 0.799377,-0.478317 1.278544,-1.2804 1.60146,-2.082484 1.75771,-3.040817 1.60146,-3.99915 1.278544,-4.801234 0.799377,-5.598109 0.002502,-6.082484",
    transform: "matrix(0.75,0,0,0.75,316.92,320.63999)",
    id: "path306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-1.98e-4 0.799377,-0.479365 1.278544,-1.281448 1.60146,-2.078323 1.75771,-3.041865 1.60146,-4.000198 1.278544,-4.802281 0.799377,-5.599156 0.002502,-6.078323",
    transform: "matrix(0.75,0,0,0.75,316.92,315.83999)",
    id: "path307"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,2.08667e-4 0.799377,-0.478958 1.278544,-1.281041 1.60146,-2.077916 1.75771,-3.041458 1.60146,-3.999791 1.278544,-4.801875 0.799377,-5.59875 0.002502,-6.077916",
    transform: "matrix(0.75,0,0,0.75,316.92,311.16)",
    id: "path308"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-8.39e-4 0.799377,-0.480006 1.278544,-1.282089 1.60146,-2.078964 1.75771,-3.042506 1.60146,-4.000839 1.278544,-4.797714 0.799377,-5.599797 0.002502,-6.078964",
    transform: "matrix(0.75,0,0,0.75,316.92,306.36)",
    id: "path309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-4.01333e-4 0.799377,-0.479568 1.278544,-1.281651 1.60146,-2.078526 1.75771,-3.042068 1.60146,-4.000401 1.278544,-4.802485 0.799377,-5.59936 0.002502,-6.078526",
    transform: "matrix(0.75,0,0,0.75,316.92,301.67999)",
    id: "path310"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.001449 0.799377,-0.480616 1.278544,-1.277491 1.60146,-2.079574 1.75771,-3.037907 1.60146,-4.001449 1.278544,-4.798324 0.799377,-5.600407 0.002502,-6.079574",
    transform: "matrix(0.75,0,0,0.75,316.92,296.87999)",
    id: "path311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.00104233 0.799377,-0.480209 1.278544,-1.282292 1.60146,-2.079167 1.75771,-3.037501 1.60146,-4.001042 1.278544,-4.797917 0.799377,-5.600001 0.002502,-6.079167",
    transform: "matrix(0.75,0,0,0.75,316.92,292.2)",
    id: "path312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,0.001663 1.118744,-0.159795 2.238536,-0.638962 3.040619,-1.441045 3.681244,-2.399379 3.998952,-3.357712 v -1.28125 L 3.681244,-5.602504 3.040619,-6.560837 2.238536,-7.357712 1.118744,-7.842087 l -1.11979167,-0.15625 -1.11979133,0.15625 -1.119792,0.484375 -0.796875,0.796875 -0.640625,0.958333 -0.322917,0.963542 v 1.28125 l 0.322917,0.958333 0.640625,0.958334 0.796875,0.802083 1.119792,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,340.2,314.28)",
    id: "path313"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 456.64062,417.92188 -5.92187,-5.76042 m 0,5.76042 5.92187,-5.76042",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 422.5625,380.95834 v 1.11979 h 65.75521 V 316.47917 H 422.5625 v 1.28125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 422.5625,380.95834 h 61.59896",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 484.16146,380.80209 0.64062,-0.16146 0.79688,-0.16146 0.47916,-0.47917 0.48438,-0.64062 0.15625,-0.64063 0.16146,-0.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 487.04167,378.07813 V 320.47917",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path318"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 486.88021,320.47917 -0.16146,-0.64062 -0.15625,-0.79688 -0.48438,-0.47917 -0.47916,-0.48437 -0.79688,-0.15625 -0.64062,-0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 484.16146,317.76042 H 422.5625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path320"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.00210067 0.799377,-0.482274 1.278544,-1.279149 1.60146,-2.081233 1.75771,-3.039566 1.60146,-3.997899 1.278544,-4.799983 0.799377,-5.602066 0.002502,-6.081233",
    transform: "matrix(0.75,0,0,0.75,316.92,285.59999)",
    id: "path321"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.001053 0.799377,-0.478114 1.278544,-1.280197 1.60146,-2.08228 1.75771,-3.040614 1.60146,-3.998947 1.278544,-4.80103 0.799377,-5.597905 0.002502,-6.08228",
    transform: "matrix(0.75,0,0,0.75,316.92,280.79999)",
    id: "path322"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,0.00145967 0.799377,-0.477707 1.278544,-1.27979 1.60146,-2.081874 1.75771,-3.040207 1.60146,-3.99854 1.278544,-4.800624 0.799377,-5.597499 0.002502,-6.081874",
    transform: "matrix(0.75,0,0,0.75,316.92,276.12)",
    id: "path323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,4.12e-4 0.799377,-0.478755 1.278544,-1.280838 1.60146,-2.077713 1.75771,-3.041255 1.60146,-3.999588 1.278544,-4.801671 0.799377,-5.598546 0.002502,-6.077713",
    transform: "matrix(0.75,0,0,0.75,316.92,271.32)",
    id: "path324"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,8.49667e-4 0.799377,-0.478317 1.278544,-1.2804 1.60146,-2.082484 1.75771,-3.040817 1.60146,-3.99915 1.278544,-4.801234 0.799377,-5.598109 0.002502,-6.082484",
    transform: "matrix(0.75,0,0,0.75,316.92,266.63999)",
    id: "path325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-1.98e-4 0.799377,-0.479365 1.278544,-1.281448 1.60146,-2.078323 1.75771,-3.041865 1.60146,-4.000198 1.278544,-4.802281 0.799377,-5.599156 0.002502,-6.078323",
    transform: "matrix(0.75,0,0,0.75,316.92,261.83999)",
    id: "path326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,2.08667e-4 0.799377,-0.478958 1.278544,-1.281041 1.60146,-2.077916 1.75771,-3.041458 1.60146,-3.999791 1.278544,-4.801875 0.799377,-5.59875 0.002502,-6.077916",
    transform: "matrix(0.75,0,0,0.75,316.92,257.16)",
    id: "path327"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-8.39e-4 0.799377,-0.480006 1.278544,-1.282089 1.60146,-2.078964 1.75771,-3.042506 1.60146,-4.000839 1.278544,-4.797714 0.799377,-5.599797 0.002502,-6.078964",
    transform: "matrix(0.75,0,0,0.75,316.92,252.36)",
    id: "path328"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-4.01333e-4 0.799377,-0.479568 1.278544,-1.281651 1.60146,-2.078526 1.75771,-3.042068 1.60146,-4.000401 1.278544,-4.802485 0.799377,-5.59936 0.002502,-6.078526",
    transform: "matrix(0.75,0,0,0.75,316.92,247.67999)",
    id: "path329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.002502,-0.001449 0.799377,-0.480616 1.278544,-1.277491 1.60146,-2.079574 1.75771,-3.037907 1.60146,-4.001449 1.278544,-4.798324 0.799377,-5.600407 0.002502,-6.079574",
    transform: "matrix(0.75,0,0,0.75,316.92,242.87999)",
    id: "path330"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00104767,0.00125633 1.118744,-0.160202 2.238536,-0.639369 3.040619,-1.441452 3.681244,-2.399785 3.998952,-3.358119 v -1.28125 L 3.681244,-5.597702 3.040619,-6.561244 2.238536,-7.358119 1.118744,-7.842494 l -1.11979167,-0.15625 -1.11979133,0.15625 -1.119792,0.484375 -0.796875,0.796875 -0.640625,0.963542 -0.322917,0.958333 v 1.28125 l 0.322917,0.958334 0.640625,0.958333 0.796875,0.802083 1.119792,0.479167 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,340.2,264.95999)",
    id: "path331"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 118.50781,248.94922 -4.4414,-4.32031 m 0,4.32031 4.4414,-4.32031 m 31.32031,549.48047 h -26.28125 m -3.96093,0 h -3.83985 m -3.95703,0 h -3.83984 m -3.96094,0 H 84.425781 m -3.957032,0 h -3.839844 m -3.960938,0 h -3.839843 m -3.960937,0 H 45.308593 m -3.839844,0 h -3.960938 m -3.960937,0 h -3.839843",
    id: "path332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/План_Санітарний комбінований.a8ebe266ad9ce8abc42344ceb9d5ff02.svg";
export { ForwardRef as ReactComponent };